module.exports = __webpack_public_path__ + "img/logo_fuelomat.40d11d00.svg";